import React, {useEffect, useState} from "react";
import {collection, doc, query, getDoc, deleteDoc, where, getDocs, setDoc, addDoc} from "firebase/firestore";
import {db} from "../../../index";
import {useNavigate, useParams} from "react-router-dom";
import globalMasehtot from "../../masehtot.json";
import SiumProgress from "./siumProgress";
import UserProgress from "../../userStatus/userProgress";
import MenuStatus from "./menuStatus";
import Spinner from "../../../spinner";
import ConfettiComponent from "../../userStatus/confetti";
import Cookies from 'js-cookie';
import PrintMasehtot from "./printMasehtot";

const SiumMasehtotStatus = () => {

    const params = useParams();
    const [sium, setSium] = useState([]);
    const [pagesWereTaken, setPagesWereTaken] = React.useState(0);
    const [pagesWereLearned, setPagesWereLearned] = React.useState(0);
    const [siumChapters, setSiumChapters] = React.useState();
    const [siumUsers, setSiumUsers] = React.useState();
    const [siumStatus, setSiumStatus] = React.useState();
    const [usersList, setUsersList] = React.useState();
    const [checkUserDetails, setCheckUserDetails] = React.useState([]);
    const [learningListSorting, setLearningListSorting] = useState("status");
    const [sortDirection, setSortDirection] = useState("asc"); // asc or desc
    const [searchQuery, setSearchQuery] = useState("");
    const [filterStillFree, setFilterStillFree] = useState(false);
    const [filterNotLearnedYet, setFilterNotLearnedYet] = useState(false);
    const [optDeleteUser, setOptDeleteUser] = React.useState([]);
    const [displayInstructions, setDisplayInstructions] = useState(false);
    const [printMode, setPrintMode] = useState(false);
    const [selectedEmails, setSelectedEmails] = useState([]);
    const [selectedEmailsUrl, setSelectedEmailsUrl] = useState('mailto:?bcc=');
    const [showSortFilter, setShowSortFilter] = useState(false);
    const [learnersFilter, setLearnersFilter] = useState("all"); // "all" or "notFinished"
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    const [showNewsModal, setShowNewsModal] = useState(false);
    const [activeTab, setActiveTab] = useState("takenMasehtot"); // "takenMasehtot" or "learningStatus"
    const NEWS_VERSION = "2025-12-02";
    const navigate = useNavigate();

    const newsContent = [
        { title: "ניהול כל הסיומים יחד!", description: "חפשו את הכפתור החדש בתפריט על מנת לנווט בין הסיומים שלכם." },
        { title: "כניסת לומדים בדרך פשוטה!", description: "מעכשיו הלומדים יכולים להיכנס ללינק הפרטי שלהם בשתי דרכים חדשות. הדרך הראשונה בדף הראשי של האתר בכפתור 'כניסה ללומדים'. הדרך השניה חפשו את כפתור החדש של 'לינק כניסה ללומדים' ושתפו אותו. כל לומד יוכל להתחבר דרך הפלאפון או האימייל שלו." },
        { title: "לא רק בישראל!", description: "עד עכשיו התקשורת של וואצטאפ הייתה רק עם קידומת ישראל, מעכשיו תוכלו לשנות את הקידומת וליצור קשר עם הלומדים מכל מדינה. כנסו להגדרות על מנת לשנות את הקידומת." },
        { title: "מצב תצוגה מורחב!", description: "הוספנו פירוט של הלומדים במצב 'תצוגת הש\"ס', אם תרצו תוכלו לבטל את הפירוט בדף ההגדרות." },
        { title: "שליחת מייל לכולם!", description: "מעכשיו אפשר לשלוח מייל לכל הלומדים, חפשו את הכפתור החדש 'שליחת מייל לכולם' (עובד רק במובייל)" }
    ];

    function handleSiumChapters(siumStatus, usersList, showStillFree = false, showNotLearnedYet = false) {
        if (!siumStatus) return;
        const chaptersNames = globalMasehtot.allChapters;
        const masehtotList = Object.entries(siumStatus)
            .filter(([masehetKey, masehet]) => {
                const allTaken = masehet.totalChapters === masehet.chapters.filter((chapter) => chapter.user).length;
                const allLearned = masehet.totalChapters === masehet.chapters.filter((chapter) => chapter.wasLearned).length;

                // If no filter is active, show all
                if (!showStillFree && !showNotLearnedYet) return true;

                // Filter: still free (not 100% taken)
                if (showStillFree && allTaken) return false;

                // Filter: didn't learn 100% yet
                if (showNotLearnedYet && allLearned) return false;

                return true;
            })
            .map(([masehetKey, masehet]) => {
            const currentMasehet = globalMasehtot.allMasehtot[masehetKey];
            const allTaken = masehet.totalChapters === masehet.chapters.filter((chapter) => chapter.user).length;
            const partialMasehetWasTaken = masehet.chapters.some((chapter) => chapter.user);
            const allLearned = masehet.totalChapters === masehet.chapters.filter((chapter) => chapter.wasLearned).length;
            const totalChapters = masehet.totalChapters;
            const takenChapters = masehet.chapters.filter((chapter) => chapter.user).length;
            const learnedChapters = masehet.chapters.filter((chapter) => chapter.wasLearned).length;

            return (<div className="accordion-item" id={masehetKey + "-Masehet"}>
                <h3 className="accordion-header">
                    <button className="accordion-button collapsed learner-list-button" type="button" data-bs-toggle="collapse"
                            data-bs-target={"#collapseTaken" + masehetKey} aria-expanded="false" aria-controls={"collapseTaken" + masehetKey}>
                        <span className="learner-badges">
                            {currentMasehet.isMishna && <span className="badge bg-success margin-right-10">משנה</span>}
                            {!allTaken && <span className="badge bg-info margin-right-10">{totalChapters} / {takenChapters} פרקים נלקחו</span>}
                            {allTaken && <span className="badge bg-info margin-right-10">המסכת נתפסה</span>}
                            {!allLearned && !allTaken && <span className="badge bg-primary margin-right-10">{learnedChapters} נלמדו</span>}
                            {!allLearned && allTaken && <span className="badge bg-primary margin-right-10">{totalChapters} / {learnedChapters} פרקים נלמדו</span>}
                            {allLearned && <span className="badge bg-primary margin-right-10">הדרן עלך</span>}
                        </span>
                        <span className="learner-name">{currentMasehet.name}</span>
                    </button>
                </h3>
                <div id={"collapseTaken" + masehetKey} className="accordion-collapse collapse" data-bs-parent="#takenMasehtotList">
                    <div className="accordion-body">
                        <h4 className="daf-click-header">לחץ על הפרק כדי לבצע פעולות</h4>
                        <div>
                            {masehet.chapters.map((chapter, c_i) => {
                                const wasTaken = chapter.user;
                                const wasLearned = chapter.wasLearned;
                                const chapterId = `${masehetKey}-${c_i}`;
                                const chapterName = chaptersNames[c_i];
                                const userKey = wasTaken ? chapter.user : null;
                                const userObj = wasTaken ? usersList[userKey] : null;
                                if (wasTaken) {
                                    userObj.key = userKey;
                                }
                                return (
                                    <>
                                        {wasLearned && <button type="button" className="btn btn-primary status-taken-button" id={chapterId} key={"shas-status-"+chapterId}
                                                               onClick={() => setCheckUserDetails(userObj)} data-bs-toggle="modal" data-bs-target="#checkUserModal">{chapterName}</button>}
                                        {!wasLearned && wasTaken && <button type="button" className="btn btn-info status-taken-button" id={chapterId}  key={"shas-status-"+chapterId}
                                                                            onClick={() => setCheckUserDetails(userObj)} data-bs-toggle="modal" data-bs-target="#checkUserModal">{chapterName}</button>}
                                        {!wasLearned && !wasTaken && <button type="button" className="btn btn-outline-secondary" id={chapterId} key={"shas-status-"+chapterId}
                                                                             data-bs-toggle="modal" data-bs-target="#addUserModal">{chapterName}</button>}
                                    </>);
                            })}
                            <div className="accordion-item margin-top-20" id={masehetKey + "-Masehet-dapim"}>
                                <h3 className="accordion-header">
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                            data-bs-target={"#collapseTaken" + masehetKey + "Dapim"} aria-expanded="false" aria-controls={"collapseTaken" + masehetKey + "Dapim"}>
                                        פירוט דפי המסכת
                                    </button>
                                </h3>
                                <div id={"collapseTaken" + masehetKey + "Dapim"} className="accordion-collapse collapse" data-bs-parent={`#${masehetKey}-Masehet-dapim`}>
                                    <div className="accordion-body perut-dapim-container">
                                        {masehet.chapters.map((chapter, c_i) => {
                                            const wasTaken = chapter.user;
                                            const wasLearned = chapter.wasLearned;
                                            const chapterId = `${masehetKey}-${c_i}`;
                                            const chapterName = chaptersNames[c_i];
                                            const userKey = wasTaken ? chapter.user : null;
                                            const userObj = wasTaken ? usersList[userKey] : null;
                                            if (wasTaken) {
                                                userObj.key = userKey;
                                            }
                                            return (
                                                <React.Fragment key={masehetKey + c_i + "-perut-dapim"}>
                                                    <div>
                                                        {wasLearned && <button type="button" className="btn btn-primary status-taken-button perut-dapim-perek" id={chapterId} key={"perut-"+chapterId}
                                                                               onClick={() => setCheckUserDetails(userObj)} data-bs-toggle="modal" data-bs-target="#checkUserModal">{chapterName}</button>}
                                                        {!wasLearned && wasTaken && <button type="button" className="btn btn-info status-taken-button perut-dapim-perek" id={chapterId} key={"perut-"+chapterId}
                                                                                            onClick={() => setCheckUserDetails(userObj)} data-bs-toggle="modal" data-bs-target="#checkUserModal">{chapterName}</button>}
                                                        {!wasLearned && !wasTaken && <button type="button" className="btn btn-outline-secondary perut-dapim-perek" id={chapterId} key={"perut-"+chapterId}
                                                                                             data-bs-toggle="modal" data-bs-target="#addUserModal">{chapterName}</button>}
                                                    </div>
                                                    <div className="perut-dapim-list">
                                                        {chapter.pages?.map((page, p_i) => {
                                                            const pageId = `${masehetKey}-${c_i}-${p_i}`;
                                                            return(<React.Fragment key={"perut-"+pageId}>
                                                                {page.learned && <button type="button" className="btn btn-primary status-taken-button daf-button-little" id={pageId}
                                                                                       onClick={() => setCheckUserDetails(userObj)} data-bs-toggle="modal" data-bs-target="#checkUserModal">{page.pageName}</button>}
                                                                {!page.learned && wasTaken && <button type="button" className="btn btn-info status-taken-button daf-button-little" id={pageId}
                                                                                                    onClick={() => setCheckUserDetails(userObj)} data-bs-toggle="modal" data-bs-target="#checkUserModal">{page.pageName}</button>}
                                                                {!page.learned && !wasTaken && <button type="button" className="btn btn-outline-secondary daf-button-little" id={pageId}
                                                                                                     data-bs-toggle="modal" data-bs-target="#addUserModal">{page.pageName}</button>}
                                                            </React.Fragment>);
                                                        })}
                                                        {chapter.mishnayot?.map((mishna, p_i) => {
                                                            const pageId = `${masehetKey}-${c_i}-${p_i}`;
                                                            return(<React.Fragment key={"perut-"+pageId}>
                                                                {mishna.learned && <button type="button" className="btn btn-primary status-taken-button mishna-button-little" id={pageId}
                                                                                         onClick={() => setCheckUserDetails(userObj)} data-bs-toggle="modal" data-bs-target="#checkUserModal">{mishna.mishnaName}</button>}
                                                                {!mishna.learned && wasTaken && <button type="button" className="btn btn-info status-taken-button mishna-button-little" id={pageId}
                                                                                                      onClick={() => setCheckUserDetails(userObj)} data-bs-toggle="modal" data-bs-target="#checkUserModal">{mishna.mishnaName}</button>}
                                                                {!mishna.learned && !wasTaken && <button type="button" className="btn btn-outline-secondary mishna-button-little" id={pageId}
                                                                                                       data-bs-toggle="modal" data-bs-target="#addUserModal">{mishna.mishnaName}</button>}
                                                            </React.Fragment>);
                                                        })}
                                                    </div>
                                                </React.Fragment>
                                            );
                                        })}
                                    </div>
                                </div>
                            </div>
                        </div>
                        {partialMasehetWasTaken && <div className="lomdim-list-container card" id={masehetKey + "Lomdim"}>
                            <span className="card-header">רשימת הלומדים:</span>
                            <ul className="lomdim-list list-group list-group-flush">
                                {masehet.usersList.map((userId) => {
                                    const lomedObj = usersList[userId];
                                    return (<li key={userId} className="list-group-item lomdim-list-item-clickable"
                                        onClick={() => { lomedObj.key = userId; setCheckUserDetails(lomedObj); }}
                                        data-bs-toggle="modal" data-bs-target="#checkUserModal"
                                    >{lomedObj.name}</li>)
                                })}
                            </ul>
                        </div>}
                    </div>
                </div>
            </div>);
        });
        return masehtotList;
    }

    function deleteUser() {
        if (optDeleteUser) {
            let haveChanges = false;
            optDeleteUser.masehtot.map((masehet) => {
                const masehetKey = masehet.masehetKey;
                const currentMasehet = sium.masehtotSelection[masehetKey];
                if (currentMasehet) {
                    masehet.chapters.map((chapter) => {
                        const chapterNum = Object.keys(chapter)[0];
                        if (chapterNum && sium.masehtotSelection[masehetKey][chapterNum]) {
                            sium.masehtotSelection[masehetKey][chapterNum] = false;
                            haveChanges = true;
                        }
                        return;
                    })
                }
                return;
            });
            if (haveChanges) {
                setDoc(doc(db, "siumim", params.siumId), sium).then(() => {
                    deleteDoc(doc(db, "users", optDeleteUser.id)).then(() => {
                        window.location.reload(false);
                    })
                })
            }
        }
    }

    function shareUserPage(user) {
        if (navigator.share) {
            navigator.share({
                title: 'סיום הש"ס',
                text: 'מצב הלמידה של ' + user.name,
                url: '/updateStatus/' + user.id,
            });
        }
    }

    function getLastModifiedInDays(lastModifed) {
        const date = new Date(lastModifed.seconds * 1000);
        const mSecInDay = 24 * 60 * 60 * 1000;
        const days = Math.floor((Date.now() - date.getTime()) / mSecInDay);
        return days;
    }

    function displayUserMasehtot(user, uIndex) {
        return user.masehtot
            .sort((a, b) => globalMasehtot.allMasehtot[a.masehetKey].index - globalMasehtot.allMasehtot[b.masehetKey].index)
            .map((masehet) => {
            const key = "user" + uIndex + "-masehet" + masehet.masehetKey;
            const chaptersFinished = masehet.chapters.filter((chapter) => {
                const chapterIndex = parseInt(Object.keys(chapter)[0]);
                return chapter[chapterIndex]; // Check if the chapter is marked as finished (true)
            }).length;
            return <div className="accordion-item" key={key}>
                <h3 className="accordion-header">
                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                            data-bs-target={"#collapse" + key} aria-expanded="false" aria-controls={"collapse" + key}>
                        {globalMasehtot.allMasehtot[masehet.masehetKey].name}
                        {globalMasehtot.allMasehtot[masehet.masehetKey].isMishna && <span className="badge bg-success margin-right-10">משנה</span>}
                        <span className="badge bg-primary margin-right-10">
                            {masehet.chapters.length} / {chaptersFinished} פרקים נלמדו
                        </span>
                    </button>
                </h3>
                <div id={"collapse" + key} className="accordion-collapse collapse" data-bs-parent="#masehtotList">
                    <div className="accordion-body chapters-list">
                        <br/>
                        {masehet.chapters
                            .sort((a, b) => parseInt(Object.keys(a)[0]) - parseInt(Object.keys(b)[0]))
                            .map((chapter) => {
                            const chapterIndex = parseInt(Object.keys(chapter)[0]);
                            const cKey = key + "-chapter" + chapterIndex;
                            const wasFinished = chapter[chapterIndex];
                            return (<>
                                <input type="checkbox" className="btn-check" id={cKey + "btn"} checked={wasFinished} disabled/>
                                <label className="btn btn-outline-primary chapter-button" htmlFor={cKey + "btn"}>{globalMasehtot.allChapters[chapterIndex]}</label>
                                </>);
                        })}
                    </div>
                </div>
            </div>
        });
    }

    function getWhatsAppLink(user, withLink) {
        const countryCode = sium?.phonePrefix || '972';
        let cleanPhone = user.phone.replace(/\D/g, '');
        if (cleanPhone.startsWith(countryCode)) {
            cleanPhone = cleanPhone.substring(countryCode.length);
        }
        if (cleanPhone.startsWith('0')) {
            cleanPhone = cleanPhone.substring(1);
        }
        const phone = countryCode + cleanPhone;

        let message = `שלום ${user.name}`;
        if (withLink) {
            message += `\n\nניתן לעדכן את מצב הלמידה שלך בקישור הבא:\nhttps://siumshas.co.il/updateStatus/${user.id}`;
        }
        return `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
    }

    function setCookie(value) {
        Cookies.set('siumShasId', value, { expires: 30 });
    }

    const loggout = () => {
        Cookies.remove('siumShasId');
        window.location = "/";
    }

    function getTalkWithUsLink() {
        return 'https://wa.me/9720509552993?text=';
    }

    // Handle sort change with direction toggle
    const handleSortChange = (sortType) => {
        if (learningListSorting === sortType) {
            const newDirection = sortDirection === "asc" ? "desc" : "asc";
            setSortDirection(newDirection);
            setSiumUsers(handleLearningList(siumStatus, usersList, sortType, newDirection, searchQuery, learnersFilter));
        } else {
            setLearningListSorting(sortType);
            setSortDirection("asc");
            setSiumUsers(handleLearningList(siumStatus, usersList, sortType, "asc", searchQuery, learnersFilter));
        }
    };

    // Handle search
    const handleSearch = (query) => {
        setSearchQuery(query);
        setSiumUsers(handleLearningList(siumStatus, usersList, learningListSorting, sortDirection, query, learnersFilter));
    };

    // Handle learners filter change
    const handleLearnersFilterChange = (filterType) => {
        setLearnersFilter(filterType);
        setSiumUsers(handleLearningList(siumStatus, usersList, learningListSorting, sortDirection, searchQuery, filterType));
    };

    // Handle masehtot filter changes
    const handleMasehtotFilterChange = (filterType, value) => {
        let newFilterStillFree = filterStillFree;
        let newFilterNotLearnedYet = filterNotLearnedYet;

        if (filterType === 'stillFree') {
            newFilterStillFree = value;
            setFilterStillFree(value);
        } else if (filterType === 'notLearnedYet') {
            newFilterNotLearnedYet = value;
            setFilterNotLearnedYet(value);
        }

        setSiumChapters(handleSiumChapters(siumStatus, usersList, newFilterStillFree, newFilterNotLearnedYet));
    };

    function shareSiumDisplayPage() {
        if (navigator.share) {
            const shareText = sium.nishmat
                ? 'מצב הש"ס של "' + sium.kehilaName + '" - ' + sium.nishmat
                : 'מצב הש"ס של "' + sium.kehilaName + '"';
            navigator.share({
                title: 'סיום הש"ס של "' + sium.kehilaName + '"',
                text: shareText,
                url: '/displaySium/' + sium.displayId
            });
        }
    }

    function shareLomdimLoginPage() {
        if (navigator.share) {
            navigator.share({
                title: 'סיום הש"ס של "' + sium.kehilaName + '"',
                text: 'סיום הש"ס של "' + sium.kehilaName + '" - כניסה ללומדים',
                url: '/lomdimLogin/' + params.siumId
            });
        }
    }

    function handleEmailSelection(userId, email, isChecked) {
        let updatedEmails = [...selectedEmails];

        if (isChecked) {
            updatedEmails.push(email);
        } else {
            updatedEmails = updatedEmails.filter(e => e !== email);
        }

        const mailtoUrl = `mailto:?bcc=${updatedEmails.join(',')}`;

        if (mailtoUrl.length > 2000) {
            alert('הכתובת ארוכה מדי. אנא בחר פחות לומדים.');
            // Uncheck the checkbox
            document.getElementById(`email-${userId}`).checked = false;
            return;
        }

        setSelectedEmails(updatedEmails);
        setSelectedEmailsUrl(mailtoUrl);
    }

    function handleLearningList(siumStatus, usersList, sorting, direction = "asc", search = "", filterType = "all") {
        const searchLower = search.toLowerCase();

        const learningList = (Object.entries(usersList)
            .filter(([, user]) => {
                // Filter by completion status
                if (filterType === "notFinished") {
                    const percent = user.userPagesTaken > 0 ? Math.floor((user.userPagesLearned * 100) / user.userPagesTaken) : 0;
                    if (percent >= 100) return false;
                }
                if (filterType === "finished") {
                    const percent = user.userPagesTaken > 0 ? Math.floor((user.userPagesLearned * 100) / user.userPagesTaken) : 0;
                    if (percent < 100) return false;
                }
                if (!search.trim()) return true;
                return (
                    user.name?.toLowerCase().includes(searchLower) ||
                    user.phone?.toLowerCase().includes(searchLower) ||
                    user.email?.toLowerCase().includes(searchLower)
                );
            })
            .sort(([, a], [, b]) => {
                let result = 0;
                if (sorting === "status") {
                    const aStatus = (a.userPagesLearned * 100) / a.userPagesTaken || 0;
                    const bStatus = (b.userPagesLearned * 100) / b.userPagesTaken || 0;
                    result = aStatus - bStatus;
                } else if (sorting === "date") {
                    result = a.lastModified - b.lastModified;
                } else if (sorting === "name") {
                    result = a.name.localeCompare(b.name, 'he');
                }
                return direction === "desc" ? -result : result;
            })
            .map(([userId, user], u_index) => {

                return(<div className="accordion-item" key={u_index + "-learningList"}>
                    <h3 className="accordion-header">
                        <button className="accordion-button collapsed learner-list-button" type="button" data-bs-toggle="collapse"
                                data-bs-target={"#collapseLearning" + u_index} aria-expanded="false"
                                aria-controls={"collapseLearning" + u_index}>
                            <span className="learner-badges">
                                {sorting === "status" && <>
                                    <span className="badge bg-primary">{user.userPagesTaken} / {user.userPagesLearned} דפים נלמדו</span>
                                    <span className="badge bg-info">{Math.floor((user.userPagesLearned * 100) / user.userPagesTaken)}%</span>
                                </>}
                                {sorting === "date" && <>
                                    <span className="badge bg-primary">{user.userPagesTaken} / {user.userPagesLearned} דפים נלמדו</span>
                                    <span className="badge bg-info">לפני {user.lastModified} ימים</span>
                                </>}
                                {sorting === "name" && <>
                                    <span className="badge bg-primary">{user.userPagesTaken} / {user.userPagesLearned} דפים נלמדו</span>
                                    <span className="badge bg-info">{Math.floor((user.userPagesLearned * 100) / user.userPagesTaken)}%</span>
                                </>}
                            </span>
                            <span className="learner-name">{user.name}</span>
                        </button>
                    </h3>
                    <div id={"collapseLearning" + u_index} className="accordion-collapse collapse"
                         data-bs-parent="#learningUsersList">
                        <div className="accordion-body">
                            <UserProgress userPerc={Math.floor((user.userPagesLearned * 100) / user.userPagesTaken)}
                                          recommendation={user.recommendedPercent}/>
                            {getUserActions(userId, user)}
                            {user.phone && <div className="user-detail-modal check-user-modal">
                                <svg fill="#000000" height="800px" width="800px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
                                     viewBox="0 0 473.806 473.806">
                                    <g>
                                        <g>
                                            <path d="M374.456,293.506c-9.7-10.1-21.4-15.5-33.8-15.5c-12.3,0-24.1,5.3-34.2,15.4l-31.6,31.5c-2.6-1.4-5.2-2.7-7.7-4
                                                        c-3.6-1.8-7-3.5-9.9-5.3c-29.6-18.8-56.5-43.3-82.3-75c-12.5-15.8-20.9-29.1-27-42.6c8.2-7.5,15.8-15.3,23.2-22.8
                                                        c2.8-2.8,5.6-5.7,8.4-8.5c21-21,21-48.2,0-69.2l-27.3-27.3c-3.1-3.1-6.3-6.3-9.3-9.5c-6-6.2-12.3-12.6-18.8-18.6
                                                        c-9.7-9.6-21.3-14.7-33.5-14.7s-24,5.1-34,14.7c-0.1,0.1-0.1,0.1-0.2,0.2l-34,34.3c-12.8,12.8-20.1,28.4-21.7,46.5
                                                        c-2.4,29.2,6.2,56.4,12.8,74.2c16.2,43.7,40.4,84.2,76.5,127.6c43.8,52.3,96.5,93.6,156.7,122.7c23,10.9,53.7,23.8,88,26
                                                        c2.1,0.1,4.3,0.2,6.3,0.2c23.1,0,42.5-8.3,57.7-24.8c0.1-0.2,0.3-0.3,0.4-0.5c5.2-6.3,11.2-12,17.5-18.1c4.3-4.1,8.7-8.4,13-12.9
                                                        c9.9-10.3,15.1-22.3,15.1-34.6c0-12.4-5.3-24.3-15.4-34.3L374.456,293.506z M410.256,398.806
                                                        C410.156,398.806,410.156,398.906,410.256,398.806c-3.9,4.2-7.9,8-12.2,12.2c-6.5,6.2-13.1,12.7-19.3,20
                                                        c-10.1,10.8-22,15.9-37.6,15.9c-1.5,0-3.1,0-4.6-0.1c-29.7-1.9-57.3-13.5-78-23.4c-56.6-27.4-106.3-66.3-147.6-115.6
                                                        c-34.1-41.1-56.9-79.1-72-119.9c-9.3-24.9-12.7-44.3-11.2-62.6c1-11.7,5.5-21.4,13.8-29.7l34.1-34.1c4.9-4.6,10.1-7.1,15.2-7.1
                                                        c6.3,0,11.4,3.8,14.6,7c0.1,0.1,0.2,0.2,0.3,0.3c6.1,5.7,11.9,11.6,18,17.9c3.1,3.2,6.3,6.4,9.5,9.7l27.3,27.3
                                                        c10.6,10.6,10.6,20.4,0,31c-2.9,2.9-5.7,5.8-8.6,8.6c-8.4,8.6-16.4,16.6-25.1,24.4c-0.2,0.2-0.4,0.3-0.5,0.5
                                                        c-8.6,8.6-7,17-5.2,22.7c0.1,0.3,0.2,0.6,0.3,0.9c7.1,17.2,17.1,33.4,32.3,52.7l0.1,0.1c27.6,34,56.7,60.5,88.8,80.8
                                                        c4.1,2.6,8.3,4.7,12.3,6.7c3.6,1.8,7,3.5,9.9,5.3c0.4,0.2,0.8,0.5,1.2,0.7c3.4,1.7,6.6,2.5,9.9,2.5c8.3,0,13.5-5.2,15.2-6.9
                                                        l34.2-34.2c3.4-3.4,8.8-7.5,15.1-7.5c6.2,0,11.3,3.9,14.4,7.3c0.1,0.1,0.1,0.1,0.2,0.2l55.1,55.1
                                                        C420.456,377.706,420.456,388.206,410.256,398.806z"/>
                                            <path d="M256.056,112.706c26.2,4.4,50,16.8,69,35.8s31.3,42.8,35.8,69c1.1,6.6,6.8,11.2,13.3,11.2c0.8,0,1.5-0.1,2.3-0.2
                                                        c7.4-1.2,12.3-8.2,11.1-15.6c-5.4-31.7-20.4-60.6-43.3-83.5s-51.8-37.9-83.5-43.3c-7.4-1.2-14.3,3.7-15.6,11
                                                        S248.656,111.506,256.056,112.706z"/>
                                            <path d="M473.256,209.006c-8.9-52.2-33.5-99.7-71.3-137.5s-85.3-62.4-137.5-71.3c-7.3-1.3-14.2,3.7-15.5,11
                                                        c-1.2,7.4,3.7,14.3,11.1,15.6c46.6,7.9,89.1,30,122.9,63.7c33.8,33.8,55.8,76.3,63.7,122.9c1.1,6.6,6.8,11.2,13.3,11.2
                                                        c0.8,0,1.5-0.1,2.3-0.2C469.556,223.306,474.556,216.306,473.256,209.006z"/>
                                        </g>
                                    </g>
                                </svg>
                                {user.phone}
                            </div>}
                            {user.email && <div className="user-detail-modal mt-2 check-user-modal">
                                <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 128">
                                    <title>EMAIL</title>
                                    <path d="M123.25,24.192c0-.018,0-.034-.005-.052s-.007-.063-.009-.094a1.734,1.734,0,0,0-.083-.408c-.006-.018,0-.037-.011-.055s-.01-.015-.013-.023a1.734,1.734,0,0,0-.227-.407c-.021-.028-.043-.053-.066-.08a1.755,1.755,0,0,0-.31-.294c-.012-.009-.022-.02-.034-.028a1.744,1.744,0,0,0-.414-.2c-.034-.012-.068-.022-.1-.032a1.733,1.733,0,0,0-.474-.073H6.5a1.733,1.733,0,0,0-.474.073c-.035.01-.068.02-.1.032a1.744,1.744,0,0,0-.414.2c-.012.008-.022.019-.034.028a1.755,1.755,0,0,0-.31.294c-.022.027-.045.052-.066.08a1.734,1.734,0,0,0-.227.407c0,.008-.01.015-.013.023s-.005.037-.011.055a1.734,1.734,0,0,0-.083.408c0,.032-.009.063-.009.094s-.005.034-.005.052v79.615c0,.023.006.045.007.068a1.737,1.737,0,0,0,.019.188c.008.051.015.1.027.152a1.74,1.74,0,0,0,.056.179c.017.047.033.094.054.139a1.729,1.729,0,0,0,.093.172c.024.04.048.081.075.119a1.743,1.743,0,0,0,.125.152c.033.036.066.072.1.106.021.019.037.042.059.061s.036.017.052.03a1.736,1.736,0,0,0,.452.263c.035.014.071.022.107.033a1.732,1.732,0,0,0,.488.085c.012,0,.023.006.035.006l.023,0H121.478l.023,0c.012,0,.023-.006.034-.006a1.732,1.732,0,0,0,.489-.085c.035-.011.07-.019.1-.033a1.736,1.736,0,0,0,.453-.263c.016-.013.036-.017.052-.03s.038-.042.059-.061c.036-.034.069-.069.1-.106a1.743,1.743,0,0,0,.125-.152c.027-.038.051-.078.075-.119a1.729,1.729,0,0,0,.093-.172c.021-.045.037-.092.054-.139a1.74,1.74,0,0,0,.056-.179c.012-.05.019-.1.027-.152a1.737,1.737,0,0,0,.019-.188c0-.023.007-.045.007-.068ZM45.8,60.316,62.858,74.993a1.751,1.751,0,0,0,2.283,0L82.2,60.316l35.512,41.741H10.289ZM8.25,99.052V28.007l34.9,30.026Zm76.6-41.019,34.9-30.026V99.052Zm31.931-32.091L81.276,56.493c-.006.005-.014.008-.02.014s-.012.014-.019.02L64,71.358,46.763,56.527c-.007-.006-.012-.014-.019-.02l-.02-.014L11.217,25.942Z"/>
                                </svg>
                                {user.email}
                            </div>}
                            <div className="user-detail-modal mt-2 check-user-modal">
                                <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 128">
                                    <title>COUNTDOWN TIMER</title>
                                    <path d="M64,12.75a51.186,51.186,0,0,0-37.2,16l-1.059-7.918a1.25,1.25,0,0,0-2.479.332L24.68,31.773a1.251,1.251,0,0,0,1.239,1.084h9.807a1.25,1.25,0,0,0,0-2.5h-7a48.594,48.594,0,1,1-6.729,8.887,1.25,1.25,0,1,0-2.152-1.271A51.256,51.256,0,1,0,64,12.75Z"/><path d="M94.009,86.526a1.249,1.249,0,0,0,1.741-.306,38.764,38.764,0,1,0-7.2,7.759,1.25,1.25,0,0,0-1.586-1.934A36.218,36.218,0,1,1,93.7,84.785,1.25,1.25,0,0,0,94.009,86.526Z"/><path d="M62.75,38.356v24.4l-17.361.094a1.25,1.25,0,0,0,.007,2.5H45.4l18.6-.1A1.25,1.25,0,0,0,65.25,64V38.356a1.25,1.25,0,0,0-2.5,0Z"/>
                                </svg>
                                <span>לומד עדכן מצב למידה לפני {user.lastModified} ימים</span>
                            </div>
                            <div className="accordion margin-top-20" id="learningMasehtotList">
                                {displayUserMasehtot(user, u_index)}
                            </div>
                        </div>
                    </div>
                </div>);
            }));
        return learningList;
    }

    function getUserActions(userKey, userObj) {
        return (
            <div className="margin-top-20 d-flex flex-wrap">
                <div className="dropdown-center sium-button-container">
                    <button className="btn btn-secondary dropdown-toggle sium-status-button dark-button" type="button"
                            data-bs-toggle="dropdown" aria-expanded="false">
                        פעולות בדף הלומד
                    </button>
                    <ul className="dropdown-menu lomed-actions-list">
                        <li className="dropdown_item-1"><a className="btn sium-status-button" href={"/updateStatus/" + userKey}>מעבר לדף הלומד</a></li>
                        <li className="dropdown_item-2"><a className="btn sium-status-button" href={"/niulSium/editUser/" + userKey}>עריכה</a></li>
                        <li className="dropdown_item-3"><button className="btn sium-status-button" data-bs-toggle="modal" data-bs-target="#deleteUserModal"
                                                                onClick={() => setOptDeleteUser(userObj)}>מחיקה</button></li>
                    </ul>
                </div>
                <div className="dropdown-center sium-button-container">
                    <button className="btn btn-secondary dropdown-toggle sium-status-button dark-button" type="button"
                            data-bs-toggle="dropdown" aria-expanded="false">
                        שיתוף דף הלומד
                    </button>
                    <ul className="dropdown-menu lomed-actions-list">
                        <li className="dropdown_item-1"><a className="btn sium-status-button" href="#" onClick={() => shareUserPage(userObj)}>שיתוף קישור</a></li>
                        {userObj.phone && <li className="dropdown_item-2"><a className="btn sium-status-button" href={getWhatsAppLink(userObj, true)} target="_blank" rel="noopener noreferrer" >שיתוף ב-WhatsApp</a></li>}
                        {userObj.email && isMobile && <li className="dropdown_item-3"><a className="btn sium-status-button" href={`mailto:${userObj.email}?subject=${encodeURIComponent('דף הסטטוס שלך')}&body=${encodeURIComponent('שלום ' + userObj.name + ',\n\nניתן לעדכן את מצב הלמידה שלך בקישור הבא:\nhttps://siumshas.co.il/updateStatus/' + userObj.id)}`}>שיתוף במייל</a></li>}
                    </ul>
                </div>
                {(userObj.phone || (isMobile && userObj.email)) && <div className="dropdown-center sium-button-container">
                    <button className="btn btn-secondary dropdown-toggle sium-status-button dark-button" type="button"
                            data-bs-toggle="dropdown" aria-expanded="false">
                        יצירת קשר עם הלומד
                    </button>
                    <ul className="dropdown-menu lomed-actions-list">
                        {userObj.phone && <li className="dropdown_item-1"><a className="btn sium-status-button" href={"tel:+972" + userObj.phone}>להתקשר ללומד</a></li>}
                        {userObj.phone && <li className="dropdown_item-2"><a className="btn sium-status-button" href={"sms:+972" + userObj.phone}>SMS</a></li>}
                        {userObj.phone && <li className="dropdown_item-3"><a className="btn sium-status-button" href={getWhatsAppLink(userObj, false)} target="_blank" rel="noopener noreferrer">WhatsApp</a></li>}
                        {userObj.email && isMobile && <li className="dropdown_item-4"><a className="btn sium-status-button" href={`mailto:${userObj.email}`}>Email</a></li>}
                    </ul>
                </div>}
            </div>
        );
    }

    const closeNewsModal = () => {
        localStorage.setItem('seenNewsVersion', NEWS_VERSION);
        setShowNewsModal(false);
    };

    useEffect(() => {
        const seenNewsVersion = localStorage.getItem('seenNewsVersion');
        if (seenNewsVersion !== NEWS_VERSION) {
            setShowNewsModal(true);
        }
    }, []);

    useEffect(() => {
        setTimeout(() => {
            const buttons = document.querySelectorAll('.sium-status-option');

            buttons.forEach(button => {
                button.addEventListener('click', function() {
                    const buttons = document.querySelectorAll('.sium-status-option');
                    buttons.forEach(button => {
                        button.style.backgroundColor = '';
                        button.style.fontWeight = '';
                    });
                    const targetId = this.getAttribute('data-bs-target');
                    const target = document.querySelector(targetId);
                    setTimeout(() => {
                        if (target && target.classList.contains('show')) {
                            this.style.backgroundColor = 'var(--bs-primary-bg-subtle)';
                            this.style.fontWeight = 'bold'
                        } else {
                            this.style.backgroundColor = '';
                            this.style.fontWeight = '';
                        }
                    }, 500);
                });
            });
        }, 3000);
        const docRef = doc(db, "siumim", params.siumId);
        getDoc(docRef).then(sium => {
            if (sium && sium.exists()) {
                setSium(sium.data());
            }
            else {
                navigate("/");
            }
        });
    },[params.siumId]);

    useEffect(() => {
        if (sium.masehtotSelection) {
            setCookie(params.siumId);

            let usersList = {};
            let pagesWereLeanred = 0;
            let pagesWereTaken = 0;
            let handleUpdateSium = false;
            let siumStatus = {};
            const startD = sium.startSium?.toDate();
            const endD = sium.endSium?.toDate();
            const weeksNum = Math.round((endD - startD) / (7 * 24 * 60 * 60 * 1000));
            const overWeeksNum = Math.round((new Date() - startD) / (7 * 24 * 60 * 60 * 1000));
            const recommendedPercent = Math.min(100, Math.max(0, Math.floor((overWeeksNum / weeksNum) * 100)));

            for (const masehetKey of Object.keys(sium.masehtotSelection)
                .sort((a, b) => globalMasehtot.allMasehtot[a].index - globalMasehtot.allMasehtot[b].index)) {
                let chapterIndex = 0;
                siumStatus[masehetKey] = {};
                siumStatus[masehetKey]["chapters"] = [];
                for (const chapter of globalMasehtot.allMasehtot[masehetKey].chapters) {
                    if (globalMasehtot.allMasehtot[masehetKey].isMishna) {
                        siumStatus[masehetKey]["isMishna"] = true;
                        let chapterMishnayot = [];
                        for (let index=0; index < chapter; index++) {
                            chapterMishnayot.push({mishnaName: globalMasehtot.allMishnayot[index], learned: false});
                        }
                        siumStatus[masehetKey]["chapters"].push({
                            mishnayot: chapterMishnayot,
                            wasTaken: sium.masehtotSelection[masehetKey][chapterIndex],
                        });
                    } else {
                        let chapterPages = [];
                        const startIndex = globalMasehtot.onlyPages.indexOf(chapter.startPage.replace(/[.:]/g, ""));
                        const endIndex = globalMasehtot.onlyPages.indexOf(chapter.endPage.replace(/[.:]/g, ""));
                        for (let index = startIndex; index <= endIndex; index++) {
                            chapterPages.push({pageName: globalMasehtot.onlyPages[index], learned: false});
                        }
                        siumStatus[masehetKey]["chapters"].push({
                            pages: chapterPages,
                            wasTaken: sium.masehtotSelection[masehetKey][chapterIndex]
                        });
                    }
                    chapterIndex++;
                }
                siumStatus[masehetKey]["totalChapters"] = sium.masehtotSelection[masehetKey].length;
                siumStatus[masehetKey]["masehetIndex"] = globalMasehtot.allMasehtot[masehetKey].index;
                siumStatus[masehetKey]["usersList"] = [];
            }


            const q = query(collection(db, "users"), where("siumId", "==", params.siumId));
            getDocs(q).then(users => {
                users.forEach((user) => {
                    const userObj = user.data();
                    let userPagesTaken = 0;
                    let userPagesLearned = 0;
                    let userMasehtot = [];
                    for (const masehet of userObj.masehtot) {
                        const masehetKey = masehet.masehetId;
                        let userChapters = [];
                        for (const chapter of masehet.chapters) {
                            const chapterIndex = parseInt(chapter.chapterNum) - 1;
                            let chapterWasLearned = false;
                            const properChapter = siumStatus[masehetKey]["chapters"][chapterIndex];
                            if (siumStatus[masehetKey]["isMishna"]) {
                                for (let i = 0; i < chapter.finish.length; i++) {
                                    if (i < siumStatus[masehetKey]["chapters"][chapterIndex]["mishnayot"].length) {
                                        siumStatus[masehetKey]["chapters"][chapterIndex]["mishnayot"][i].learned = chapter.finish[i];
                                    }
                                }
                                chapterWasLearned = chapter.finish.every((page) => page);
                                userChapters.push({[chapterIndex]: chapterWasLearned});
                                if (properChapter.user) {
                                    if (!properChapter["wasLearned"] && chapterWasLearned) {
                                        pagesWereLeanred += 1;
                                        properChapter["user"] = user.id;
                                        properChapter["wasLearned"] = chapterWasLearned;
                                    }
                                } else {
                                    pagesWereTaken += 1;
                                    if (chapterWasLearned) {
                                        pagesWereLeanred += 1;
                                    }
                                }
                                userPagesTaken += 1;
                                if (chapterWasLearned) {
                                    userPagesLearned += 1;
                                }
                            } else {
                                const partialLearned = properChapter["user"] && siumStatus[masehetKey]["chapters"][chapterIndex]["pages"].some((page) => page.learned);
                                for (let i = 0; i < chapter.finish.length; i++) {
                                    if (i < siumStatus[masehetKey]["chapters"][chapterIndex]["pages"].length) {
                                        siumStatus[masehetKey]["chapters"][chapterIndex]["pages"][i].learned = chapter.finish[i];
                                    }
                                }
                                const chapterPagesLearned = chapter.finish.filter((page) => page).length;
                                chapterWasLearned = chapterPagesLearned === chapter.finish.length;
                                userChapters.push({[chapterIndex]: chapterWasLearned});
                                if (properChapter.user) {
                                    if (!partialLearned && chapterPagesLearned > 0) {
                                        pagesWereLeanred += chapterPagesLearned;
                                        properChapter["user"] = user.id;
                                        properChapter["wasLearned"] = chapterWasLearned;
                                    }
                                } else {
                                    pagesWereTaken += chapter.finish.length;
                                    pagesWereLeanred += chapterPagesLearned;
                                }
                                userPagesTaken += chapter.finish.length;
                                userPagesLearned += chapterPagesLearned;
                            }

                            if (properChapter && !properChapter.wasTaken) {
                                handleUpdateSium = true;
                                properChapter.wasTaken = true;
                            }
                            if (!properChapter.user) {
                                properChapter["user"] = user.id;
                                properChapter["wasLearned"] = chapterWasLearned;
                            }
                        }
                        siumStatus[masehetKey]["usersList"].push(user.id);
                        userMasehtot.push({masehetKey: masehetKey, chapters: userChapters});
                    }
                    usersList[user.id] = {
                        id: user.id,
                        name: userObj.fullName,
                        phone: userObj.phone,
                        email: userObj.email,
                        userPagesTaken: userPagesTaken,
                        userPagesLearned: userPagesLearned,
                        masehtot: userMasehtot,
                        recommendedPercent: recommendedPercent,
                        lastModified: getLastModifiedInDays(userObj.lastModified)
                    };
                });

                if (pagesWereTaken === 0) {
                    setDisplayInstructions(true);
                }
                setPagesWereLearned(pagesWereLeanred);
                setPagesWereTaken(pagesWereTaken);
                setSiumChapters(handleSiumChapters(siumStatus, usersList));

                setSiumUsers(handleLearningList(siumStatus, usersList, "status"));
                setSiumStatus(siumStatus);
                setUsersList(usersList);

                let displayPagesList = {};
                for (const masehetKey of Object.keys(siumStatus)) {
                    displayPagesList[masehetKey] = {
                        "chapters": siumStatus[masehetKey]["chapters"],
                        "masehetIndex": siumStatus[masehetKey]["masehetIndex"],
                        "isMishna": siumStatus[masehetKey]["isMishna"] ? true : false
                    }
                }

                outerLoop:
                for (const masehetKey of Object.keys(siumStatus)) {
                    for (let chapterIndex=0; chapterIndex < siumStatus[masehetKey]["chapters"].length; chapterIndex++) {
                        const currentChapter = siumStatus[masehetKey]["chapters"][chapterIndex];
                        if (currentChapter && currentChapter.wasTaken && !currentChapter.user) {
                            handleUpdateSium = true;
                            break outerLoop;
                        }
                    }
                }

                if (handleUpdateSium) {
                    for (const masehetKey of Object.keys(sium.masehtotSelection)) {
                        const masehetChapters = siumStatus[masehetKey]["chapters"];
                        for (let chapterIndex=0; chapterIndex < masehetChapters.length; chapterIndex++) {
                            if (masehetChapters[chapterIndex] && masehetChapters[chapterIndex].user) {
                                sium.masehtotSelection[masehetKey][chapterIndex] = true;
                            } else {
                                sium.masehtotSelection[masehetKey][chapterIndex] = false;
                            }
                        }
                    }
                }
                sium.lastAccessed = new Date().getTime();
                if (!sium.created) {
                    sium.created = new Date().getTime();
                }
                const displaySium = {
                    displayPagesList: displayPagesList,
                    pagesTaken: pagesWereTaken,
                    pagesLearned: pagesWereLeanred,
                    siumId: params.siumId
                }
                if (sium.displayId) {
                    setDoc(doc(db, "displaySium", sium.displayId), displaySium);
                    setDoc(doc(db, "siumim", params.siumId), sium);
                    setSium(sium)
                } else {
                    addDoc(collection(db, "displaySium"), displaySium).then((docRef) => {
                        sium.displayId = docRef.id;
                        setDoc(doc(db, "siumim", params.siumId), sium);
                        setSium(sium)
                    });
                }
            });
        }
    }, [sium]);

    if (sium && sium.kehilaName && globalMasehtot.allMasehtot) {
        const today = new Date();
        const endD = sium.endSium?.toDate();
        const daysNum = Math.round((endD - today) / (24 * 60 * 60 * 1000));
        return(
            <>
                {!printMode && <div className="sium-main">
                    <div className="sium-main-container" style={sium.backgroundColor ? { backgroundColor: sium.backgroundColor } : {}}>
                        <div className="sium-main-header">
                            <div className="basad">
                                <span>בס"ד</span>
                                <br/>
                                <span>להצלחת עם ישראל</span>
                            </div>
                            <div className="menu-icon">
                                <a data-bs-toggle="offcanvas" href="#menuStatus" role="button" aria-controls="menuStatus">
                                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#414a87"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"><path fillRule="evenodd" clipRule="evenodd" d="M2 7a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1zm0 5a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1zm1 4a1 1 0 1 0 0 2h18a1 1 0 1 0 0-2H3z" fill="#414a87"></path></g></svg>
                                </a>
                            </div>
                        </div>
                        <div className="sium-logo">
                            <a href={"/mySiumim/" + params.siumId} className="sium-logo-img" aria-label="ניהול סיומים"></a>
                        </div>
                        <div className="grid p-3 text-primary-emphasis bg-primary-subtle border border-primary-subtle rounded-3 sium-titles">
                            {sium.nishmat && <span>הלימוד {sium.nishmat}</span>}
                            <h2><span className="niul-header">ניהול </span>חלוקת הש"ס של {sium.kehilaName}</h2>
                            {sium.logo && <div alt="logo" className={sium.logo}/>}
                            {daysNum > 0 && <p className="bold days-left">נותרו עוד {daysNum} ימים</p>}
                        </div>
                        {displayInstructions && <div className="sium-content">
                            <h2>שנתחיל...?</h2>
                            <p>
                                מוזמנים להוסיף לומדים חדשים באמצעות <span className="bold">"הוסף לומד".</span><br/>
                                <span>בדף "הוסף לומד" ישנה אפשרות לשתף את הדף, על מנת שהחבר'ה שיוסיפו את עצמם.</span><br/>
                            </p>
                            <p>
                                באמצעות <span className="bold">מצב הש"ס</span> ניתן לעקוב אחרי מצב הש"ס בכל רגע נתון.
                            </p>
                            <p>
                                <span className="bold">"רשימת הלומדים"</span> מעניקה לכם אפשרות לצפות בנתוני הלומד, ולבצע מגוון פעולות הקשורות ללומד. <br/>
                            </p>
                            <p>
                                <span className="bold">בהצלחה רבה!</span>
                            </p>
                            <p>
                                <span>צריכים עזרה? מוזמנים לכתוב לנו </span>
                                <a target="_blank" rel="noopener noreferrer" href={getTalkWithUsLink()}>בוואצטאפ</a>
                            </p>
                        </div>}
                        <div id="displayMasehtot" className="sium-status-options-container">
                            <div>
                                <div
                                    className={`sium-status-option ${sium.pagesCounter && pagesWereTaken >= sium.pagesCounter ? 'disabled' : ''}`}
                                    onClick={() => {
                                        if (!(sium.pagesCounter && pagesWereTaken >= sium.pagesCounter)) {
                                            window.location = "/addUser/" + params.siumId;
                                        }
                                    }}
                                    tabIndex={0}
                                    title={sium.pagesCounter && pagesWereTaken >= sium.pagesCounter ? "הש\"ס נלקח במלואו" : ""}
                                >
                                    <svg fill="#414a87" height="200px" width="200px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 511.999 511.999"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <g> <path d="M503.292,210.719H398.127l-2.721-33.724c-0.005-0.053-0.015-0.104-0.021-0.157c-0.003-0.031-0.007-0.062-0.01-0.092 l-8.003-99.08c-0.365-4.522-4.141-8.007-8.68-8.007H133.303c-4.537,0-8.314,3.484-8.68,8.007l-2.457,30.415 c-0.387,4.794,3.185,8.994,7.979,9.381c4.807,0.389,8.993-3.185,9.381-7.979l1.81-22.408h229.323l6.617,81.912h-16.777 c-4.81,0-8.708,3.899-8.708,8.708s3.898,8.708,8.708,8.708h18.195l1.962,24.312H131.344l1.966-24.312h198.163 c4.81,0,8.708-3.899,8.708-8.708s-3.898-8.708-8.708-8.708H134.718l2.356-29.139c0.387-4.794-3.185-8.994-7.979-9.381 c-4.803-0.385-8.994,3.186-9.381,7.979l-5.845,72.273H8.708c-4.809,0-8.708,3.899-8.708,8.708s3.899,8.708,8.708,8.708h101.747 c-1.457,1.996-3.484,3.93-6.064,6.31c-6.083,5.611-14.414,13.295-14.414,27.819c0,14.525,8.331,22.209,14.414,27.82 c5.787,5.339,8.807,8.43,8.807,15.019c0,6.588-3.02,9.68-8.807,15.018c-6.083,5.611-14.414,13.295-14.414,27.82 s8.331,22.21,14.414,27.822c5.787,5.339,8.807,8.432,8.807,15.022c0,6.59-3.02,9.683-8.807,15.022 c-6.083,5.611-14.414,13.298-14.414,27.822c0,4.809,3.899,8.708,8.708,8.708s8.708-3.899,8.708-8.708 c0-6.59,3.02-9.682,8.807-15.022c6.083-5.611,14.414-13.297,14.414-27.822c0-14.525-8.331-22.211-14.414-27.822 c-5.787-5.339-8.807-8.432-8.807-15.022c0-6.588,3.02-9.681,8.807-15.019c6.084-5.611,14.414-13.295,14.414-27.819 c0-14.525-8.331-22.209-14.414-27.82c-5.787-5.339-8.807-8.43-8.807-15.019c0-6.588,3.02-9.68,8.807-15.018 c4.73-4.363,10.804-9.998,13.278-19.111h253.047c2.474,9.113,8.548,14.748,13.278,19.111c5.787,5.339,8.807,8.43,8.807,15.018 c0,6.589-3.02,9.681-8.807,15.019c-6.083,5.611-14.414,13.296-14.414,27.82s8.332,22.209,14.414,27.819 c5.787,5.339,8.807,8.43,8.807,15.019c0,6.59-3.02,9.682-8.807,15.022c-6.083,5.611-14.414,13.298-14.414,27.822 c0,14.525,8.332,22.211,14.414,27.822c5.787,5.339,8.807,8.432,8.807,15.022c0,4.809,3.898,8.708,8.708,8.708 c4.81,0,8.708-3.899,8.708-8.708c0-14.525-8.331-22.21-14.413-27.822c-5.788-5.339-8.808-8.432-8.808-15.022 c0-6.59,3.02-9.683,8.808-15.022c6.083-5.611,14.413-13.298,14.413-27.822s-8.332-22.209-14.414-27.82 c-5.787-5.339-8.807-8.43-8.807-15.018c0-6.589,3.02-9.681,8.807-15.019c6.083-5.611,14.414-13.296,14.414-27.82 c0-14.524-8.332-22.209-14.414-27.819c-2.58-2.38-4.607-4.315-6.064-6.31h101.747c4.81,0,8.708-3.899,8.708-8.708 S508.102,210.719,503.292,210.719z"></path> </g> </g> </g></svg>
                                    <span>הוסף לומד</span>
                                </div>
                                <div className={`sium-status-option ${activeTab === 'takenMasehtot' ? 'active' : ''}`}
                                     onClick={() => setActiveTab('takenMasehtot')}
                                     tabIndex={0}>
                                    <svg className="margin-right-10" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" fill="#414a87" stroke="#414a87"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <title>torah</title> <g id="torah"> <circle cx="8.5" cy="5.5" r="2.5" style={{fill:"none", stroke: "#414a87", strokeLinecap: "round",strokeLinejoin:"round",strokeWidth: "2px"}}></circle> <path d="M17,14V57.016A2.984,2.984,0,0,0,19.984,60H60V18H21a4.272,4.272,0,0,1-4-4.5h0A4.272,4.272,0,0,1,21,9H60" style={{fill:"none", stroke: "#414a87", strokeLinecap: "round",strokeLinejoin:"round",strokeWidth: "2px"}}></path> <line x1="60" y1="12" x2="34" y2="12" style={{fill:"none", stroke: "#414a87", strokeLinecap: "round",strokeLinejoin:"round",strokeWidth: "2px"}}></line> <line x1="37" y1="15" x2="23" y2="15" style={{fill:"none", stroke: "#414a87", strokeLinecap: "round",strokeLinejoin:"round",strokeWidth: "2px"}}></line> <line x1="40" y1="15" x2="44" y2="15" style={{fill:"none", stroke: "#414a87", strokeLinecap: "round",strokeLinejoin:"round",strokeWidth: "2px"}}></line> <line x1="60" y1="15" x2="53" y2="15" style={{fill:"none", stroke: "#414a87", strokeLinecap: "round",strokeLinejoin:"round",strokeWidth: "2px"}}></line> <polygon points="39 29 30.34 44 47.66 44 39 29" style={{fill:"none", stroke: "#414a87", strokeLinecap: "round",strokeLinejoin:"round",strokeWidth: "2px"}}></polygon> <polygon points="39 49 30.34 34 47.66 34 39 49" style={{fill:"none", stroke: "#414a87", strokeLinecap: "round",strokeLinejoin:"round",strokeWidth: "2px"}}></polygon> <line x1="20" y1="18" x2="20" y2="60" style={{fill:"none", stroke: "#414a87", strokeLinecap: "round",strokeLinejoin:"round",strokeWidth: "2px"}}></line> <path d="M28,60V56a4,4,0,0,1-4-4H20" style={{fill:"none",stroke:"#414a87",strokeLinejoin:"round",strokeWidth:"2px"}}></path> <path d="M28,18.355V22a4,4,0,0,0-4,4H20.308" style={{fill:"none", stroke: "#414a87", strokeLinecap: "round",strokeLinejoin:"round",strokeWidth: "2px"}}></path> <path d="M52,60V56a4,4,0,0,0,4-4h4" style={{fill:"none",stroke:"#414a87",strokeLinejoin:"round",strokeWidth:"2px"}}></path> <path d="M52,18v4a4,4,0,0,1,4,4h4" style={{fill:"none",stroke:"#414a87",strokeLinejoin:"round",strokeWidth:"2px"}}></path> <line x1="39" y1="25" x2="39" y2="23" style={{fill:"none", stroke: "#414a87", strokeLinecap: "round",strokeLinejoin:"round",strokeWidth: "2px"}}></line> <line x1="39" y1="53" x2="39" y2="55" style={{fill:"none", stroke: "#414a87", strokeLinecap: "round",strokeLinejoin:"round",strokeWidth: "2px"}}></line> <circle cx="11.044" cy="23.014" r="1.069"></circle> <line x1="7" y1="37" x2="10" y2="40" style={{fill:"none", stroke: "#414a87", strokeLinecap: "round",strokeLinejoin:"round",strokeWidth: "2px"}}></line> <line x1="10" y1="37" x2="7" y2="40" style={{fill:"none", stroke: "#414a87", strokeLinecap: "round",strokeLinejoin:"round",strokeWidth: "2px"}}></line> </g> </g></svg>
                                    <span>מצב הש"ס</span>
                                </div>
                                <div className={`sium-status-option ${activeTab === 'learningStatus' ? 'active' : ''}`}
                                     onClick={() => setActiveTab('learningStatus')}
                                     tabIndex={0}>
                                    <svg height="200px" width="200px" version="1.1" id="Icons" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="#414a87"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"><g> <path d="M6,7H0.9C0.4,7,0,7.4,0,7.9v9.1C0,17.6,0.4,18,0.9,18H6c1.7,0,3,1.3,3,3V10C9,8.3,7.7,7,6,7z"></path> <path d="M18.1,7H13c-1.7,0-3,1.3-3,3v11c0-1.7,1.3-3,3-3h5.1c0.5,0,0.9-0.4,0.9-0.9V7.9C19,7.4,18.6,7,18.1,7z"></path> </g> <path d="M31.9,17.6L29,11.8C28.9,6.4,24.4,2,19,2c-2.8,0-5.4,1.2-7.3,3.2C12.1,5.1,12.5,5,13,5h5.1C19.7,5,21,6.3,21,7.9v9.1 c0,1.6-1.3,2.9-2.9,2.9H13c-0.6,0-1,0.4-1,1v6c0,0.5,0.3,0.9,0.8,1l10,2c0.1,0,0.1,0,0.2,0c0.2,0,0.5-0.1,0.6-0.2 c0.2-0.2,0.4-0.5,0.4-0.8v-4h2c1.7,0,3-1.3,3-3v-3h2c0.3,0,0.7-0.2,0.9-0.5S32,17.9,31.9,17.6z"></path> </g></svg>
                                    <span>רשימת לומדים</span>
                                </div>
                            </div>
                            <div className={`collapse ${activeTab === 'takenMasehtot' ? 'show' : ''}`} id="takenMasehtot">
                                <div className="card card-body">
                                    <SiumProgress dapim={true} takenPages={Math.floor((pagesWereTaken/sium.pagesCounter) * 100)}
                                                  learnedPages={Math.floor((pagesWereLearned/sium.pagesCounter) * 100)}/>
                                    <div className="sium-status-btns">
                                        {sium.displayId && <button className="btn dark-button share-display-sium" onClick={() => shareSiumDisplayPage()}>
                                            <span>שתף את מצב הש"ס</span>
                                        </button>}
                                        <button className="btn dark-button share-display-sium" onClick={() => setPrintMode(true)}>
                                            <span>הדפס מצב הש"ס</span>
                                        </button>
                                    </div>

                                    {/* Filter checkboxes */}
                                    <div className="masehtot-filter-container margin-top-10 margin-bottom-10">
                                        <label className="masehtot-filter-label">סינון:</label>
                                        <div className="form-check form-check-inline">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                id="filterStillFree"
                                                checked={filterStillFree}
                                                onChange={(e) => handleMasehtotFilterChange('stillFree', e.target.checked)}
                                            />
                                            <label className="form-check-label" htmlFor="filterStillFree">
                                                פנויות
                                            </label>
                                        </div>
                                        <div className="form-check form-check-inline">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                id="filterNotLearnedYet"
                                                checked={filterNotLearnedYet}
                                                onChange={(e) => handleMasehtotFilterChange('notLearnedYet', e.target.checked)}
                                            />
                                            <label className="form-check-label" htmlFor="filterNotLearnedYet">
                                                לא נלמדו
                                            </label>
                                        </div>
                                    </div>
                                    <div className="accordion" id="takenMasehtotList">
                                        {siumChapters}
                                    </div>
                                </div>
                            </div>
                            <div className={`collapse ${activeTab === 'learningStatus' ? 'show' : ''}`} id="learningStatus">
                                <div className="card card-body">
                                    <div className="sium-status-btns">
                                        {usersList && Object.values(usersList).some(user => user.email) && (
                                            <button
                                                className="btn dark-button share-display-sium"
                                                data-bs-toggle="modal"
                                                data-bs-target="#sendEmailModal"
                                            >
                                                שלח מייל לכולם
                                            </button>
                                        )}
                                        <button className="btn dark-button share-display-sium" onClick={() => shareLomdimLoginPage()}>
                                            לינק כניסה ללומדים
                                        </button>
                                    </div>
                                    {/* Sort & Filter toggle button */}
                                    <button
                                        className="btn dark-button share-display-sium margin-bottom-10 margin-top-20"
                                        onClick={() => setShowSortFilter(!showSortFilter)}
                                    >
                                        מיון וסינון
                                        <span style={{ marginRight: '6px', fontSize: '12px' }}>{showSortFilter ? '▲' : '▼'}</span>
                                    </button>

                                    {showSortFilter && (<div className="sort-filter-section">
                                    <div className="btn-group sorting-container margin-bottom-15" role="group" aria-label="sort learining list buttons">
                                        <label className="sorting-label">מיין לפי:</label>
                                        <button
                                            type="button"
                                            className={`btn sort-button ${learningListSorting === "status" ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleSortChange("status")}
                                        >
                                            מצב למידה
                                            {learningListSorting === "status" && (
                                                <span className="sort-direction-icon">
                                                    {sortDirection === "asc" ? "▲" : "▼"}
                                                </span>
                                            )}
                                        </button>

                                        <button
                                            type="button"
                                            className={`btn sort-button ${learningListSorting === "date" ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleSortChange("date")}
                                        >
                                            תאריך עדכון
                                            {learningListSorting === "date" && (
                                                <span className="sort-direction-icon">
                                                    {sortDirection === "asc" ? "▲" : "▼"}
                                                </span>
                                            )}
                                        </button>

                                        <button
                                            type="button"
                                            className={`btn sort-button ${learningListSorting === "name" ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleSortChange("name")}
                                        >
                                            שם הלומד
                                            {learningListSorting === "name" && (
                                                <span className="sort-direction-icon">
                                                    {sortDirection === "asc" ? "▲" : "▼"}
                                                </span>
                                            )}
                                        </button>
                                    </div>

                                    {/* Filter options */}
                                    <div className="btn-group sorting-container margin-bottom-10" role="group" aria-label="filter learners">
                                        <label className="sorting-label">הצג:</label>
                                        <button
                                            type="button"
                                            className={`btn sort-button ${learnersFilter === "all" ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleLearnersFilterChange("all")}
                                        >
                                            הכל
                                        </button>
                                        <button
                                            type="button"
                                            className={`btn sort-button ${learnersFilter === "notFinished" ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleLearnersFilterChange("notFinished")}
                                        >
                                            לא סיימו
                                        </button>
                                        <button
                                            type="button"
                                            className={`btn sort-button ${learnersFilter === "finished" ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleLearnersFilterChange("finished")}
                                        >
                                            סיימו
                                        </button>
                                    </div>

                                    {/* Search input */}
                                    <div className="learners-search-container margin-bottom-10">
                                            {!searchQuery && <span className="learners-search-icon">🔍</span>}
                                            <input
                                                type="text"
                                                className="form-control learners-search-input"
                                                placeholder="חיפוש לומד לפי שם, טלפון, אימייל..."
                                                value={searchQuery}
                                                onChange={(e) => handleSearch(e.target.value)}
                                            />
                                            {searchQuery && (
                                                <button
                                                    type="button"
                                                    className="learners-search-clear"
                                                    onClick={() => handleSearch("")}
                                                >
                                                    ✕
                                                </button>
                                            )}
                                        </div>
                                    </div>)}
                                    <div className="accordion margin-top-20" id="learningUsersList">
                                        {siumUsers}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal fade" id="deleteUserModal" tabIndex="-1" aria-labelledby="delete user" aria-hidden="true">
                            {optDeleteUser && <div className="modal-dialog">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h1 className="modal-title fs-5">מחיקת לומד</h1>
                                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                    </div>
                                    <div className="modal-body">
                                        <span>האם אתה בטוח שאתה רוצה למחוק את {optDeleteUser.name}?</span>
                                    </div>
                                    <div className="modal-footer">
                                        <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" onClick={() => setOptDeleteUser(null)}>ביטול</button>
                                        <button type="button" className="btn btn-danger" onClick={() => deleteUser()}>מחק</button>
                                    </div>
                                </div>
                            </div>}
                        </div>
                        <div className="modal fade" id="sendEmailModal" tabIndex="-1" aria-labelledby="send email to users" aria-hidden="true">
                            <div className="modal-dialog modal-dialog-scrollable">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h1 className="modal-title fs-5">שליחת מייל לכולם</h1>
                                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                    </div>
                                    <div className="modal-body">
                                        <div className="form-check-list">
                                            {usersList && Object.entries(usersList)
                                                .filter(([, user]) => user.email)
                                                .map(([userId, user]) => (
                                                    <div className="form-check emails-list" key={userId}>
                                                        <input
                                                            className="form-check-input margin-left-15"
                                                            type="checkbox"
                                                            id={`email-${userId}`}
                                                            onChange={(e) => handleEmailSelection(userId, user.email, e.target.checked)}
                                                        />
                                                        <label className="form-check-label" htmlFor={`email-${userId}`}>
                                                            {user.name}
                                                        </label>
                                                    </div>
                                                ))}
                                        </div>
                                        {!isMobile && selectedEmails.length > 0 && (
                                            <div className="mt-3">
                                                <label className="form-label">כתובות המייל (העתק והדבק בתוכנת המייל שלך):</label>
                                                <textarea
                                                    className="form-control"
                                                    rows="4"
                                                    readOnly
                                                    value={selectedEmails.join(', ')}
                                                />
                                            </div>
                                        )}
                                    </div>
                                    <div className="modal-footer modal-footer-spread">
                                        <button
                                            type="button"
                                            className="btn btn-secondary"
                                            onClick={() => {
                                                setSelectedEmails([]);
                                                setSelectedEmailsUrl('mailto:?bcc=');
                                                document.querySelectorAll('.form-check-input[id^="email-"]').forEach(cb => cb.checked = false);
                                            }}
                                        >
                                            איפוס
                                        </button>
                                        <div className="modal-footer-left">
                                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">ביטול</button>
                                            {isMobile ? (
                                                <a
                                                    className="btn btn-primary"
                                                    href={selectedEmailsUrl}
                                                    onClick={(e) => {
                                                        if (!selectedEmailsUrl || selectedEmailsUrl === 'mailto:?bcc=') {
                                                            e.preventDefault();
                                                            alert('אנא בחר לפחות לומד אחד');
                                                        }
                                                    }}
                                                >
                                                    שלח
                                                </a>
                                            ) : (
                                                <button
                                                    type="button"
                                                    className="btn btn-primary"
                                                    onClick={() => {
                                                        if (!selectedEmails.length) {
                                                            alert('אנא בחר לפחות לומד אחד');
                                                            return;
                                                        }
                                                        navigator.clipboard.writeText(selectedEmails.join(', '))
                                                            .then(() => alert('כתובות המייל הועתקו ללוח'))
                                                            .catch(() => alert('שגיאה בהעתקה'));
                                                    }}
                                                >
                                                    העתק
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal fade" id="addUserModal" tabIndex="-1" aria-labelledby="add user" aria-hidden="true">
                            <div className="modal-dialog">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h1 className="modal-title fs-5">הדף טרם נלקח</h1>
                                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                    </div>
                                    <div className="modal-body sium-status-options-container add-user-modal">
                                        <span>תרצה להוסיף לומד חדש?</span>
                                        <div className="sium-status-option" onClick={() => window.location = "/addUser/" + params.siumId} tabIndex={0}>
                                            <svg fill="#414a87" height="200px" width="200px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 511.999 511.999"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <g> <path d="M503.292,210.719H398.127l-2.721-33.724c-0.005-0.053-0.015-0.104-0.021-0.157c-0.003-0.031-0.007-0.062-0.01-0.092 l-8.003-99.08c-0.365-4.522-4.141-8.007-8.68-8.007H133.303c-4.537,0-8.314,3.484-8.68,8.007l-2.457,30.415 c-0.387,4.794,3.185,8.994,7.979,9.381c4.807,0.389,8.993-3.185,9.381-7.979l1.81-22.408h229.323l6.617,81.912h-16.777 c-4.81,0-8.708,3.899-8.708,8.708s3.898,8.708,8.708,8.708h18.195l1.962,24.312H131.344l1.966-24.312h198.163 c4.81,0,8.708-3.899,8.708-8.708s-3.898-8.708-8.708-8.708H134.718l2.356-29.139c0.387-4.794-3.185-8.994-7.979-9.381 c-4.803-0.385-8.994,3.186-9.381,7.979l-5.845,72.273H8.708c-4.809,0-8.708,3.899-8.708,8.708s3.899,8.708,8.708,8.708h101.747 c-1.457,1.996-3.484,3.93-6.064,6.31c-6.083,5.611-14.414,13.295-14.414,27.819c0,14.525,8.331,22.209,14.414,27.82 c5.787,5.339,8.807,8.43,8.807,15.019c0,6.588-3.02,9.68-8.807,15.018c-6.083,5.611-14.414,13.295-14.414,27.82 s8.331,22.21,14.414,27.822c5.787,5.339,8.807,8.432,8.807,15.022c0,6.59-3.02,9.683-8.807,15.022 c-6.083,5.611-14.414,13.298-14.414,27.822c0,4.809,3.899,8.708,8.708,8.708s8.708-3.899,8.708-8.708 c0-6.59,3.02-9.682,8.807-15.022c6.083-5.611,14.414-13.297,14.414-27.822c0-14.525-8.331-22.211-14.414-27.822 c-5.787-5.339-8.807-8.432-8.807-15.022c0-6.588,3.02-9.681,8.807-15.019c6.084-5.611,14.414-13.295,14.414-27.819 c0-14.525-8.331-22.209-14.414-27.82c-5.787-5.339-8.807-8.43-8.807-15.019c0-6.588,3.02-9.68,8.807-15.018 c4.73-4.363,10.804-9.998,13.278-19.111h253.047c2.474,9.113,8.548,14.748,13.278,19.111c5.787,5.339,8.807,8.43,8.807,15.018 c0,6.589-3.02,9.681-8.807,15.019c-6.083,5.611-14.414,13.296-14.414,27.82s8.332,22.209,14.414,27.819 c5.787,5.339,8.807,8.43,8.807,15.019c0,6.59-3.02,9.682-8.807,15.022c-6.083,5.611-14.414,13.298-14.414,27.822 c0,14.525,8.332,22.211,14.414,27.822c5.787,5.339,8.807,8.432,8.807,15.022c0,4.809,3.898,8.708,8.708,8.708 c4.81,0,8.708-3.899,8.708-8.708c0-14.525-8.331-22.21-14.413-27.822c-5.788-5.339-8.808-8.432-8.808-15.022 c0-6.59,3.02-9.683,8.808-15.022c6.083-5.611,14.413-13.298,14.413-27.822s-8.332-22.209-14.414-27.82 c-5.787-5.339-8.807-8.43-8.807-15.018c0-6.589,3.02-9.681,8.807-15.019c6.083-5.611,14.414-13.296,14.414-27.82 c0-14.524-8.332-22.209-14.414-27.819c-2.58-2.38-4.607-4.315-6.064-6.31h101.747c4.81,0,8.708-3.899,8.708-8.708 S508.102,210.719,503.292,210.719z"></path> </g> </g> </g></svg>
                                            <span>הוסף לומד</span>
                                        </div>
                                    </div>
                                    <div className="modal-footer">
                                        <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">ביטול</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal fade" id="checkUserModal" tabIndex="-1" aria-labelledby="check user details" aria-hidden="true">
                            {checkUserDetails && <div className="modal-dialog">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h1 className="modal-title fs-5">
                                            {checkUserDetails.name}
                                            <span className="badge bg-primary margin-right-10">
                                                {checkUserDetails.userPagesLearned}/{checkUserDetails.userPagesTaken} דפים נלמדו
                                            </span>
                                        </h1>
                                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                    </div>
                                    <div className="modal-body sium-status-options-container check-user-modal">
                                        {checkUserDetails.phone && <div className="user-detail-modal check-user-modal">
                                            <svg fill="#000000" height="800px" width="800px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
                                                 viewBox="0 0 473.806 473.806">
                                                <g>
                                                    <g>
                                                        <path d="M374.456,293.506c-9.7-10.1-21.4-15.5-33.8-15.5c-12.3,0-24.1,5.3-34.2,15.4l-31.6,31.5c-2.6-1.4-5.2-2.7-7.7-4
                                                            c-3.6-1.8-7-3.5-9.9-5.3c-29.6-18.8-56.5-43.3-82.3-75c-12.5-15.8-20.9-29.1-27-42.6c8.2-7.5,15.8-15.3,23.2-22.8
                                                            c2.8-2.8,5.6-5.7,8.4-8.5c21-21,21-48.2,0-69.2l-27.3-27.3c-3.1-3.1-6.3-6.3-9.3-9.5c-6-6.2-12.3-12.6-18.8-18.6
                                                            c-9.7-9.6-21.3-14.7-33.5-14.7s-24,5.1-34,14.7c-0.1,0.1-0.1,0.1-0.2,0.2l-34,34.3c-12.8,12.8-20.1,28.4-21.7,46.5
                                                            c-2.4,29.2,6.2,56.4,12.8,74.2c16.2,43.7,40.4,84.2,76.5,127.6c43.8,52.3,96.5,93.6,156.7,122.7c23,10.9,53.7,23.8,88,26
                                                            c2.1,0.1,4.3,0.2,6.3,0.2c23.1,0,42.5-8.3,57.7-24.8c0.1-0.2,0.3-0.3,0.4-0.5c5.2-6.3,11.2-12,17.5-18.1c4.3-4.1,8.7-8.4,13-12.9
                                                            c9.9-10.3,15.1-22.3,15.1-34.6c0-12.4-5.3-24.3-15.4-34.3L374.456,293.506z M410.256,398.806
                                                            C410.156,398.806,410.156,398.906,410.256,398.806c-3.9,4.2-7.9,8-12.2,12.2c-6.5,6.2-13.1,12.7-19.3,20
                                                            c-10.1,10.8-22,15.9-37.6,15.9c-1.5,0-3.1,0-4.6-0.1c-29.7-1.9-57.3-13.5-78-23.4c-56.6-27.4-106.3-66.3-147.6-115.6
                                                            c-34.1-41.1-56.9-79.1-72-119.9c-9.3-24.9-12.7-44.3-11.2-62.6c1-11.7,5.5-21.4,13.8-29.7l34.1-34.1c4.9-4.6,10.1-7.1,15.2-7.1
                                                            c6.3,0,11.4,3.8,14.6,7c0.1,0.1,0.2,0.2,0.3,0.3c6.1,5.7,11.9,11.6,18,17.9c3.1,3.2,6.3,6.4,9.5,9.7l27.3,27.3
                                                            c10.6,10.6,10.6,20.4,0,31c-2.9,2.9-5.7,5.8-8.6,8.6c-8.4,8.6-16.4,16.6-25.1,24.4c-0.2,0.2-0.4,0.3-0.5,0.5
                                                            c-8.6,8.6-7,17-5.2,22.7c0.1,0.3,0.2,0.6,0.3,0.9c7.1,17.2,17.1,33.4,32.3,52.7l0.1,0.1c27.6,34,56.7,60.5,88.8,80.8
                                                            c4.1,2.6,8.3,4.7,12.3,6.7c3.6,1.8,7,3.5,9.9,5.3c0.4,0.2,0.8,0.5,1.2,0.7c3.4,1.7,6.6,2.5,9.9,2.5c8.3,0,13.5-5.2,15.2-6.9
                                                            l34.2-34.2c3.4-3.4,8.8-7.5,15.1-7.5c6.2,0,11.3,3.9,14.4,7.3c0.1,0.1,0.1,0.1,0.2,0.2l55.1,55.1
                                                            C420.456,377.706,420.456,388.206,410.256,398.806z"/>
                                                        <path d="M256.056,112.706c26.2,4.4,50,16.8,69,35.8s31.3,42.8,35.8,69c1.1,6.6,6.8,11.2,13.3,11.2c0.8,0,1.5-0.1,2.3-0.2
                                                            c7.4-1.2,12.3-8.2,11.1-15.6c-5.4-31.7-20.4-60.6-43.3-83.5s-51.8-37.9-83.5-43.3c-7.4-1.2-14.3,3.7-15.6,11
                                                            S248.656,111.506,256.056,112.706z"/>
                                                        <path d="M473.256,209.006c-8.9-52.2-33.5-99.7-71.3-137.5s-85.3-62.4-137.5-71.3c-7.3-1.3-14.2,3.7-15.5,11
                                                            c-1.2,7.4,3.7,14.3,11.1,15.6c46.6,7.9,89.1,30,122.9,63.7c33.8,33.8,55.8,76.3,63.7,122.9c1.1,6.6,6.8,11.2,13.3,11.2
                                                            c0.8,0,1.5-0.1,2.3-0.2C469.556,223.306,474.556,216.306,473.256,209.006z"/>
                                                    </g>
                                                </g>
                                                </svg>
                                            {checkUserDetails.phone}
                                        </div>}
                                        {checkUserDetails.email && <div className="user-detail-modal mt-2 check-user-modal">
                                            <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 128">
                                                <title>EMAIL</title>
                                                <path d="M123.25,24.192c0-.018,0-.034-.005-.052s-.007-.063-.009-.094a1.734,1.734,0,0,0-.083-.408c-.006-.018,0-.037-.011-.055s-.01-.015-.013-.023a1.734,1.734,0,0,0-.227-.407c-.021-.028-.043-.053-.066-.08a1.755,1.755,0,0,0-.31-.294c-.012-.009-.022-.02-.034-.028a1.744,1.744,0,0,0-.414-.2c-.034-.012-.068-.022-.1-.032a1.733,1.733,0,0,0-.474-.073H6.5a1.733,1.733,0,0,0-.474.073c-.035.01-.068.02-.1.032a1.744,1.744,0,0,0-.414.2c-.012.008-.022.019-.034.028a1.755,1.755,0,0,0-.31.294c-.022.027-.045.052-.066.08a1.734,1.734,0,0,0-.227.407c0,.008-.01.015-.013.023s-.005.037-.011.055a1.734,1.734,0,0,0-.083.408c0,.032-.009.063-.009.094s-.005.034-.005.052v79.615c0,.023.006.045.007.068a1.737,1.737,0,0,0,.019.188c.008.051.015.1.027.152a1.74,1.74,0,0,0,.056.179c.017.047.033.094.054.139a1.729,1.729,0,0,0,.093.172c.024.04.048.081.075.119a1.743,1.743,0,0,0,.125.152c.033.036.066.072.1.106.021.019.037.042.059.061s.036.017.052.03a1.736,1.736,0,0,0,.452.263c.035.014.071.022.107.033a1.732,1.732,0,0,0,.488.085c.012,0,.023.006.035.006l.023,0H121.478l.023,0c.012,0,.023-.006.034-.006a1.732,1.732,0,0,0,.489-.085c.035-.011.07-.019.1-.033a1.736,1.736,0,0,0,.453-.263c.016-.013.036-.017.052-.03s.038-.042.059-.061c.036-.034.069-.069.1-.106a1.743,1.743,0,0,0,.125-.152c.027-.038.051-.078.075-.119a1.729,1.729,0,0,0,.093-.172c.021-.045.037-.092.054-.139a1.74,1.74,0,0,0,.056-.179c.012-.05.019-.1.027-.152a1.737,1.737,0,0,0,.019-.188c0-.023.007-.045.007-.068ZM45.8,60.316,62.858,74.993a1.751,1.751,0,0,0,2.283,0L82.2,60.316l35.512,41.741H10.289ZM8.25,99.052V28.007l34.9,30.026Zm76.6-41.019,34.9-30.026V99.052Zm31.931-32.091L81.276,56.493c-.006.005-.014.008-.02.014s-.012.014-.019.02L64,71.358,46.763,56.527c-.007-.006-.012-.014-.019-.02l-.02-.014L11.217,25.942Z"/>
                                            </svg>
                                            {checkUserDetails.email}
                                        </div>}
                                        {getUserActions(checkUserDetails.key, checkUserDetails)}
                                        {checkUserDetails.masehtot && checkUserDetails.masehtot.length > 0 && (
                                            <div className="user-pieces-in-bookstatus">
                                                <h5 className="user-pieces-header">המסכתות של הלומד ({checkUserDetails.masehtot.length})</h5>
                                                <div className="accordion" id="checkUserMasehtotList">
                                                    {displayUserMasehtot(checkUserDetails, 'modal')}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                    <div className="modal-footer">
                                        <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" onClick={() => setCheckUserDetails(null)}>ביטול</button>
                                    </div>
                                </div>
                            </div>}
                        </div>
                        {showNewsModal && (
                            <div className="modal fade show" style={{display: 'block', backgroundColor: 'rgba(0,0,0,0.5)'}} tabIndex="-1">
                                <div className="modal-dialog modal-dialog-centered">
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <h1 className="modal-title fs-5">חדשות האפליקציה 🎉</h1>
                                            <button type="button" className="btn-close" onClick={closeNewsModal} aria-label="Close"></button>
                                        </div>
                                        <div className="modal-body">
                                            {newsContent.map((news, index) => (
                                                <div key={index} className="mb-3">
                                                    <h5>{news.title}</h5>
                                                    <p>{news.description}</p>
                                                    {index < newsContent.length - 1 && <hr/>}
                                                </div>
                                            ))}
                                        </div>
                                        <div className="modal-footer">
                                            <button type="button" className="btn btn-primary" onClick={closeNewsModal}>הבנתי!</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                        {sium && <MenuStatus sium={sium} siumId={params.siumId} loggoutFunc={loggout} forceInstructions={setDisplayInstructions}></MenuStatus>}
                        <div className="sium-bottom-page">
                            <span> © כל הזכויות שמורות לאתר סיום הש"ס</span>
                        </div>
                    </div>
                    {pagesWereLearned === sium.pagesCounter && <ConfettiComponent></ConfettiComponent>}
                </div>}
                {printMode && <PrintMasehtot siumStatus={siumStatus} usersList={usersList} pagesWereTaken={pagesWereTaken}
                       pagesWereLearned={pagesWereLearned} sium={sium} back={setPrintMode}></PrintMasehtot>}
            </>
        )
    } else {
        return (<Spinner/>);
    }

}

export default SiumMasehtotStatus;
